import React from "react";
import DarphaLogo from "@/assets/darpha_logo_digital.png";
import { useLayout } from "@app/providers/LayoutContext";
import "./TopInfoBar.css";

const TopInfoBar = () => {
  const { isDarkTheme, toggleTheme } = useLayout();

  return (
    <div className="header-controlpanel">
      <img src={DarphaLogo} alt="Darpha Logo" className="darpha-logo" />
      <h1>
        <span className="title-controlpanel">Darpha Maintenance App</span>
      </h1>
      <button
        className="theme-toggle-btn"
        onClick={toggleTheme}
        title={isDarkTheme ? "Cambiar a tema claro" : "Cambiar a tema oscuro"}
        aria-label="Cambiar tema"
      >
        <i className={`fa-solid ${isDarkTheme ? "fa-sun" : "fa-moon"}`}></i>
      </button>
    </div>
  );
};

export default TopInfoBar;
